import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ProductCardContainer')(({ theme, isSelected }) =>
  css({
    cursor: 'pointer',
    borderRadius: '3px',
    outline: isSelected && `solid 1px ${theme.colors.blue}`,
    outlineOffset: isSelected && '-1px',
  }),
);

export default themeStyles;
